<a class="app-logo clickable-cursor" href="https://nandbox.com/en/">
  <img src="./assets/img/logo-w-text.svg" />
</a>

<app-signup
  class="auth"
  [countryIso]="(authService?.authCollection$ | async)?.countryIso"
>
</app-signup>
